import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { MasterDataService } from "app/shared/services/master-data.service";
import { ToastrService } from "ngx-toastr";
import { CardService } from "../../../services/card.service";
import { AddBankAccountRequest } from "app/modules/bank-account/models/bank-account.model";
import { BankAccountService } from "app/modules/bank-account/services/bank-account.service";
import { ConstantsKey } from "app/shared/constant/constants-keys";
import { Constants } from "app/shared/constant/constants";

@Component({
  selector: 'add-bank-account-card',
  templateUrl: './add-bank-account-card.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AddBankAccountForCardComponent implements OnInit {

  public addBankAccountRequest = new AddBankAccountRequest();
  public bankDropdownItemList: any;
  public consumerId: any;
  public showLoader: boolean = false;
  public showAccountNo: boolean = false;
  public validIFSC: boolean = false;
  public showAddBankForm : boolean = false;
  public bankRelationshipList = Constants.payerList;
  @Output() childCallbackForAddBankAccountForm = new EventEmitter<string>();

  constructor(
    public bankAccountService: BankAccountService,
    public toast: ToastrService, 
    public router: Router) { }

  ngOnInit() {
    this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
    this.getBankList();
  }

  getBankList() {
    var singleObject;
    var localBankDropdownItemList;
    this.bankAccountService.getPaymentModes().subscribe(res => {

      localBankDropdownItemList = res.body;
      for (let i = 0; i < localBankDropdownItemList.length; i++) {
        singleObject = localBankDropdownItemList[i];
        if (singleObject.categoryName == "Net Banking") {
          this.bankDropdownItemList = singleObject.paymentModeCategories;
        }
      }

    });
  }

  addBankAccount(data) {
    if (data === true) {
      this.showLoader = true;
      if (this.addBankAccountRequest.number === this.addBankAccountRequest.confirmAccNo) {
        this.addBankAccountRequest.consumerId = this.consumerId;
        this.addBankAccountRequest.default = true;
        this.addBankAccountRequest.type = 'SAVINGS';
        this.addBankAccountRequest.isDefault = true;
        console.log(JSON.stringify(this.addBankAccountRequest));
        
        this.bankAccountService.addMyBankAccount(this.addBankAccountRequest).subscribe(resp => {
          this.showLoader = false;
          this.toast.success("Bank account added successfully", "Success !!");
          this.childCallbackForAddBankAccountForm.emit('ADD_BANK_ACCOUNT_ADDED');
        }, error => {
          this.showLoader = false;
          this.toast.error(error.error.message);
        });
      } else {
        this.showLoader = false;
        this.toast.error("Account no and confirm account no. must be same");
      }
      // if (this.addBankAccountRequest.number === this.addBankAccountRequest.confirmAccNo) {
      //   this.addBankAccountRequest.consumerId = this.consumerId;
      //   this.bankAccountService.addMyBankAccount(this.addBankAccountRequest).subscribe(resp => {
      //     this.showLoader = false;
      //     this.toast.success("Bank account added successfully", "Success !!");
      //     this.childCallbackForAddBankAccountForm.emit('ADD_BANK_ACCOUNT_ADDED');
      //   }, error => {
      //     this.showLoader = false;
      //     this.toast.error(error.error.message);
      //   });
      // } else {
      //   this.showLoader = false;
      //   this.toast.error("Account no and confirm account no. must be same");
      // }
    }
  }

  alphaNumberOnly (e) {  // Accept only alpha numerics, not special characters 
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
        return true;
    }
    e.preventDefault();
    return false;
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onPaste(e) {
    e.preventDefault();
    return false;
  }

  goToCashoutStep() {
    this.router.navigate(['/cashout']);
  }
}
